interface FloatingActionMenuProps {
  visible: boolean;
  onExploreClick?: () => void; // Made optional
  onBookingClick: () => void;
}

export default function FloatingActionMenu({ 
  visible, 
  onExploreClick,
  onBookingClick 
}: FloatingActionMenuProps) {
  return (
    <div 
      className={`fixed bottom-6 right-6 z-50 transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-[200%]'
      }`}
    >
      <div className="flex flex-col gap-3">
        {/* Conditionally render Explore button */}
        {onExploreClick && (
          <button
            onClick={onExploreClick}
            className="w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
            aria-label="Explore Services"
          >
            <span className="text-xl">🎯</span>
          </button>
        )}
        <button
          onClick={onBookingClick}
          className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
          aria-label="Book Consultation"
        >
          <span className="text-xl">📅</span>
        </button>
      </div>
    </div>
  );
}
